import {resolveDataTranslator} from "../../components/modules/file-browser/data-translators";
import {FILE_TYPE} from "../../constants/file-image-types";
import axios from "axios";
import store from "@frontend/store"

let abortController = new AbortController()
export default {
  listBySource(source, params = {}) {
    const translator = resolveDataTranslator(source)
    abortController.abort();
    abortController = new AbortController()
    const promise = axios.get(source, {
      signal: abortController.signal,
      params,
    })

    if (translator) {
      return promise.then((response) => {
        response.data.items = response.data.items.map(translator);
        return response;
      })
    }

    return promise
  },
  getFileList (params = {}) {
    return axios.get('/file/file_list', { params })
  },
  getSalsifyProductList (params = {}) {
    return axios.get('/salsify/retrieve-products', { params })
  },
  getSalsifyProduct (params = {}) {
    return axios.get('/salsify/retrieve-product', { params })
  },
  fetchAsinImage (asin) {
    return axios.post('/external-product/fetch-asin', { asin })
  },
  fetchAsinImages (asin) {
    return axios.post('/external-product/fetch-asin-images', { asin })
  },
  fetchAsinMedia (input) {
    return axios.post('/external-product/fetch-asin-media', { input })
  },
  importRemoteAsset ({ url, type, name }) {
    return axios.post('/video/import-remote-asset', { url, type, name })
  },
  getFolderList (params = {}) {
    return axios.get('/file/folder_list', { params })
  },
  getFileFolderList (params = {}) {
    return axios.get('/file/file-folder-list', { params })
  },
  getFileFolderContent (folderId, page) {
    return axios.get('/file/file-folder-content', { params: { folderId, pageNumber: page } })
  },
  getFolderAvailablePermissions () {
    return axios.get(`/file/folder-available-permissions`)
  },
  getFolderPermissionsData (folderIds, type) {
    return axios.get(`/file/folder-permissions-data`, {
      params: {
        folderIds: folderIds.join(','),
        type
      }
    })
  },
  syncFolderPermissions(folderIds, userIds, userGroupIds, type) {
    return axios.post(`/file/sync-folder-permissions`, { userIds, userGroupIds, folderIds, type });
  },
  previewRequest(fileIds) {
    return axios.post('/file/view', { file_ids: fileIds });
  },

  addFolder(parent_id, url) {
    return axios.post(url, {parent_id});
  },

  updateFolder(folderId, folderName, folderCompanyId) {
    return axios.put('/file/update_folder', { folderId, folderName, folderCompanyId });
  },

  storeStockTags(postData) {
    return axios.post('/file/stock_tags', postData);
  },

  fetchStockTags() {
    return axios.get('/file/stock_tags');
  },

  deleteFolder(folderId, options = {}) {
    return axios.delete('/file/delete_folder', {
      data: {
        folderId,
        confirm_brief_unlink: options.confirmBriefUnlink || false,
      },
    });
  },

  deleteProductFolder(folderId) {
    return axios.delete('/file/delete_product_folder', { data: { folderId } });
  },

  downloadFolder(folderId, url = null) {
    if (url) {
      return axios.post('/file/share/files/download_folder', { folderId, url });
    } else {
      return axios.post('/file/download_folder', { folderId });
    }
  },

  downloadProductFolder(folderId) {
    return axios.post('/file/download_product_folder', { folderId });
  },

  downloadFolderFiles(fileId, url = null) {
    if (url) {
      return axios.post('/file/share/files/download_folder_files', { fileId, url });
    } else {
      return axios.post('/file/download_folder_files', { fileId });
    }
  },

  uploadFolderFile(formData) {
    return axios.post('/file/upload_folder_file', formData);
  },

  uploadProductFile(formData, onUploadProgress) {
    return axios.post('/file/uploadimg/upload_images', formData, {
      onUploadProgress: (event) => onUploadProgress(event),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) =>
        response.data.paths.map((url, index) => ({
          name: response.data.filenames[index],
          url: `${location.origin}/share?file=${url}`,
        }))
      )
      .catch(() => {
        this.errorString = 'Something went wrong. Try again later.'
      });
  },

  storeExternalResourceToFolderFile(postData) {
    return axios.post('/file/store_external_resources_folder_file', postData);
  },

  getMultipartUploadedParts(formData) {
    return axios.get('/file/upload_folder_file/' + formData.uploadId + '?key=' + formData.key);
  },

  signPartUpload(postData) {
    return axios.get('/file/upload_folder_file/' + postData.uploadId + '/' + postData.partNumber + '?key=' + postData.key);
  },

  completeMultipartUpload(postData) {
      return axios.post('/file/upload_folder_file/' + postData.uploadId + '/complete', postData);
  },

  abortMultipartUpload(postData) {
    return axios.delete('/file/upload_folder_file/' + postData.uploadId + '?key=' + postData.key + '&id=' + postData.id);
  },

  deleteFolderFile(fileId) {
    return axios.delete('/file/delete_folder_file', { data: { fileId } });
  },

  deleteStockFile(fileId, filePath) {
    return axios.delete('/file/delete_stock_file', { data: { fileId, filePath } });
  },

  deleteProductFile(fileId) {
    return axios.delete('/file/delete_product_file', { data: { fileId } });
  },

  deleteMultipleProductFile(fileId, folderId = []) {
    return axios.delete('/file/delete_multiple_product_file', { data: { fileId, folderId } });
  },

  deleteMultipleStockImages(fileId, folderId = []) {
    return axios.delete('/file/delete_multiple_stock_images', { data: { fileId, folderId } });
  },

  deleteMultipleBackgroundImages(fileId, folderId = []) {
    return axios.delete('/file/delete_multiple_background_images', { data: { fileId, folderId } });
  },
  
  deleteMultipleFolderFile(fileId) {
    return axios.delete('/file/delete_multiple_folder_file', { data: { fileId } });
  },

  async deleteBynderAssets(assetIds) {
    store.commit('fileBrowser/SET_LIST_LOADING', true);

    try {
      const { data } = await axios.post('/bynder/delete-assets', { asset_ids: assetIds });

      if (data.status === 'error') {
        toastr.error(data.message);
      } else {
        toastr.success(data.message);
      }
    } catch (error) {
      console.log('Error', error.message);
      toastr.error(error.message);
    }
  },

  async deleteSalsifyAssets(ids) {
    store.commit('fileBrowser/SET_LIST_LOADING', true);

    const assetIds = store.getters['fileBrowser/items']
      .filter(item => ids.includes(item.id))
      .map(asset => asset.asset_id);

    try {
      const { data } = await axios.post('/salsify/delete-assets', { asset_ids: assetIds });

      if (data.status === 'error') {
        toastr.error(data.message);
      } else {
        toastr.success(data.message);
      }
    } catch (error) {
      console.log('Error', error.message);
      toastr.error(error.message);
    }
  },

  async downloadBynderAssets(assetIds) {
    const assets = store.getters['fileBrowser/items']
      .filter(item => assetIds.includes(item.id))
      .map(asset => ({
        id: asset.id,
        name: asset.name,
        extension: asset.extension,
      }));

    return await axios.post('/bynder/download-assets', { assets: assets });
  },

  async downloadSalsifyAssets(assetIds) {
    const assets = store.getters['fileBrowser/items']
      .filter(item => assetIds.includes(item.id))
      .map(asset => ({
        id: asset.id,
        name: asset.name,
        extension: asset.extension,
        path: asset.path,
      }));

    return await axios.post('/salsify/download-assets', { assets: assets });
  },

  async downloadBoxAssets(fileIds) {
    const files = store.getters['fileBrowser/items']
      .filter(item => fileIds.includes(item.id))
      .map(item => ({
        name: item.name,
        download_url: item.download_url,
      }));

    return await axios.post('/box/download', { files: files });
  },

  async importBoxAssets(files) {
    return await axios.post('/box/import-assets', { files });
  },

  convertFolderFile(fileId, format, conversionOption) {
    return axios.post('/file/convert_folder_file', { fileId, format, conversionOption });
  },
  
  convertProductImage(fileId, format, conversionOption) {
    return axios.post('/file/convert_product_image', { fileId, format, conversionOption });
  },

  compressFolderFile(fileId, options, replaceOriginalImage) {
    return axios.post('/file/compress_folder_file', { fileId, replaceOriginalImage, ...{settings: {...options}} }, options);
  },

  convertFolderFileUsingBackgroundJob(fileId, format, folderId, conversionOption) {
    return axios.post('/file/convert_folder_file_using_background_job', { fileId, format, folderId, conversionOption });
  },
  
  resizeFolderFile(fileId, option) {
    return axios.post('/file/resize_folder_file', { fileId, ...option });
  },

  resizeFolderFileUsingBackgroundJob(fileId, option) {
    return axios.post('/file/resize_folder_file_using_background_job', { fileId, ...option });
  },

  compressFolderFileUsingBackgroundJob(fileId, options, replaceOriginalImage) {
    return axios.post('/file/compress_folder_file_using_background_job', { fileId, replaceOriginalImage, ...{settings: {...options}} }, options);
  },

  updateFolderFile(data) {
    return axios.put('/file/update_folder_file', data);
  },
  
  dropFileFolder(data){
    return axios.put('/file/drop_folder_file', data);
  },

  updateFileFolderFile(data) {
    return axios.put('/file/update_file_folder_file', data);
  },

  updateFile(id, data) {
    return axios.put('/file/' + id, data);
  },
  
  download(data) {
    return axios.post('/file/download', { data })
  },

  createShareLink(data) {
    return axios.post('/file/share/link', data)
  },

  createFolderShareLink(folderId) {
    return axios.post('/file/share/folder-share-link', { folderId })
  },

  updateShareLink(data) {
    return axios.post('/file/share/update_link', data)
  },

  sendSharedAction(data) {
    return axios.post('/file/share/send_shared_action', data)
  },

  getSettingsValue() {
    return axios.get('/file/compress_settings')
  },

  saveSettingsValue(setting_value) {
    return axios.post('/file/compress_settings', setting_value)
  },
  
  sendMail(subject, body, email, shareLink) {
    return axios.post(`/send_mail`, { subject, body, email, shareLink })
  },

  saveRemoveBGImage(data) {
    return axios.post('/video/remove-bg-image', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  getIconPath(extension) {
    return axios.get(`/file/get_icon_path/${extension}`)
  },
  
  addPSDAssetFolder(data) {
    return axios.post('/file/add_psd_asset_folder', data)
  },

  updateThumbnails(file_ids) {
    return axios.post('/file/update_thumbnails', { file_ids })
  },
  saveCropImages(itemIds, replace, isProduct = 0) {
    return axios.post('/file/crop_image', { itemIds, replace, isProduct})
  },
  getBreadcrumbs(folderIds, tab) {
    return axios.post(`/file/breadcrumbs/`, { folderIds: folderIds, tab: tab });
  },
  
  duplicateFiles(file_ids) {
    return axios.post(`/file/duplicate`, { file_ids });
  },

  copyFolders(folder_ids) {
    return axios.post(`/folder/copy`, { folder_ids });
  },
  
  storeProductFiles(data) {
    return axios.post(`/file/uploadimg/store`, data);
  },

  addToFavorites (ids = [], verbose = null) {
    return axios.post(`/file/favorite/add`, { ids, verbose })
  },

  removeFromFavorites (ids = [], verbose = null) {
    return axios.post(`/file/favorite/remove`, { ids, verbose })
  },

  checkProductFilesExist(data) {
    return axios.post(`/file/uploadimg/check-exist-product-fiels`, data);
  },

  itemsPerPage (value = null) {
    return axios.get('/file/items-per-page', { params: { value } })
  },

  gridDensity (value = null) {
    return axios.get('/file/grid-density', { params: { value } })
  },

  getPageNumberForFileInFolder({ fileId, folderId, types, pageSize } ) {
    return axios.get('/file/file-page-in-folder', {  params: { fileId, folderId, types, pageSize }});
  },
  createFolderByName(url, data) {
    return axios.post(url, data);
  },
  checkLinkedFolderExists(url, data) {
    return axios.post(url, data);
  },
  markExistence(file) {
    const formData = new FormData();
    formData.append('file', file)
    return axios.post('/file/mark-existence', formData, { responseType: 'blob' })
  },
  mergePPTX(data) {
    return axios.post('/file/merge_pptx', data, { responseType: 'blob' });
  },
  generateTemplatesFileLists(data) {
    return axios.post('/file/generate-file-list', data, { responseType: 'blob' });
  },
  getFolderByName(folderName) {
    return axios.get(`/file/folder?folderName=${folderName}`);
  },
  checkRootFolderExists(folderName) {
    return axios.post('/file/check-root-folder-exists', { folderName });
  },
  getFolderName(folderId) {
    return axios.post(`/file/folder/${folderId}/name`);
  },
  getFolderContent(folderId, page) {
    return axios.get(`/file/folder_content?folderId=${folderId}&pageNumber=${page}&pageSize=10`);
  },
  async isPlatformAvailable(platform) {
    return await axios.post('/platforms/is-platform-available', { platform });
  },
  async isPublishToBynder() {
    return await axios.post('/bynder/check-publish-mode');
  },
  updateSortOrder(ids, parentId) {
    return axios.post('/file/sort-order', { ids, parent_id: parentId ?? null });
  },
};
